export default "__VITE_ASSET__ChYlUqHF__"